export function getPortConfiguration(deviceType: string) {
  switch (deviceType) {
    case '2GE8FE':
      return {
        count: 10,
        names: ['G1', 'P1', 'P2', 'P3', 'P4', 'G2', 'P5', 'P6', 'P7', 'P8'],
        speeds: [1000, 100, 100, 100, 100, 1000, 100, 100, 100, 100],
      };
    case '4GE12FE':
      return {
        count: 16,
        names: [
          'P1',
          'P2',
          'P3',
          'P4',
          'P5',
          'P6',
          'G1',
          'P7',
          'P8',
          'P9',
          'P10',
          'P11',
          'P12',
          'G4',
          'G2',
          'G3',
        ],
        speeds: [
          100, 100, 100, 100, 100, 100, 1000, 100, 100, 100, 100, 100, 100,
          1000, 1000, 1000,
        ],
      };
    case '4GE20FE':
      return {
        count: 24,
        names: [
          'G1',
          'G2',
          'G3',
          'G4',
          'G5',
          'G6',
          'G7',
          'G8',
          'G9',
          'G10',
          'G11',
          'G12',
          'G13',
          'G14',
          'G15',
          'G16',
          'G17',
          'G18',
          'G19',
          'G20',
          'G21',
          'G22',
          'G23',
          'G24',
        ],
        speeds: Array(24).fill(1000),
      };
    default:
      return { count: 10, names: [], speeds: [] };
  }
}

// Interface helper functions
export function getInterfaceCounters(deviceType: string) {
  const portConfig = getPortConfiguration(deviceType);
  return portConfig.names.map((name, index) => ({
    interface: index + 1,
    name,
    rx_bytes: Math.floor(Math.random() * 1000000),
    tx_bytes: Math.floor(Math.random() * 1000000),
    rx_packets: Math.floor(Math.random() * 10000),
    tx_packets: Math.floor(Math.random() * 10000),
    rx_errors: Math.floor(Math.random() * 10),
    tx_errors: Math.floor(Math.random() * 10),
  }));
}
